module.exports = __webpack_public_path__ + "media/images/logos/logo_thumb-1441909b234c6b8fe368e18a2ab527bb.png";